import React from 'react';
import CollaborationPartner from '../CollaborationPartner';
import { useAppContext } from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { useCmsText } from '../../hooks/useCmsText';

function Camera({ color }: { color?: string }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke={color || '#000'}
			className="w-12 h-12 md:w-14 md:h-14"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
			/>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
			/>
		</svg>
	);
}

function TextClipboard({ color }: { color?: string }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke={color || '#000'}
			className="w-12 h-12 md:w-14 md:h-14"
      style={{ color: color }}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
			/>
		</svg>
	);
}

const Start = () => {
	const { state } = useAppContext();
	const navigate = useNavigate();
	const { renderPlainText: renderText } = useCmsText();

	return (
		<div
			className="container mx-auto px-4 py-5 w-full sm:px-8 md:px-12 mt-5"
			style={{ maxWidth: '600px' }}
		>
			<div className="text-center">
				<h1
					className="font-semibold tracking-tight leading-tight text-4xl sm:text-5xl md:text-6xl mb-6"
					style={{ color: state.branding?.fontColor }}
				>
					{renderText(
						'home_header',
						'Har du mottatt en mistenkelig melding?'
					)}
				</h1>
				<p
		          	className="mt-3 leading-relaxed text-base sm:text-lg md:text-xl"
		          	style={{ color: state.branding?.fontColor }}
		       	>
					{renderText(
						'home_subtitle',
						'Sjekk og rapporter med Skjold.ai. Vi har hjulpet tusenvis av personer med å unngå nettsvindel og datakriminalitet'
					)}
				</p>
			</div>

			<div className="flex flex-row mt-20">
				<div
					onClick={() => navigate('/image-checker')}
					className="w-1/2 bg-white p-5 py-10 mr-5 cursor-pointer rounded-md border-x border-y border-stone-300"
					style={{ backgroundColor: state.branding?.boxBackground }}
				>
					<div className="text-center flex flex-col items-center justify-center">
						{/* <img
							width={'40'}
							height={'40'}
							src="/images/camera.png"
							alt="camera"
						/> */}
            			<Camera color={state.branding?.fontColor} />
						<h3
			              className="text-base sm:text-lg font-medium mt-5"
							style={{ color: state.branding?.fontColor }}
						>
							{renderText('home_action2_title', 'Del et skjermbilde')}
						</h3>
					</div>
				</div>
				<div
					onClick={() => navigate('/text-checker')}
					className="w-1/2 bg-white p-5 py-10 cursor-pointer rounded-md border-x border-y border-stone-300"
					style={{ backgroundColor: state.branding?.boxBackground }}
				>
					<div className="text-center flex flex-col items-center justify-center">
						{/* <img
							width={'40'}
							height={'40'}
							src="/images/clipboard.png"
							alt="paste"
						/> */}
            <TextClipboard color={state.branding?.fontColor} />
						<h3
							className="text-base sm:text-lg font-medium mt-5"
						style={{ color: state.branding?.fontColor }}
						>
							{renderText('home_action1_title', 'Lim inn tekst')}
						</h3>
					</div>
				</div>
			</div>

			{/* <div className="mt-10 text-center">
        <h2 className="text-sm font-medium mb-2">
          {renderText('collaboration_heading', 'I samarbeid med')}
        </h2>
        <p className="text-xs">
          {renderText('collaboration_text', `${state.partnerName || 'Testpartner'}\nSkjold.ai hjelper kunder av ${state.partnerName || 'Testpartner'} med digital trygghet.`)}
        </p>
      </div> */}

			{state.partnerName && <CollaborationPartner />}
		</div>
	);
};

export default Start;
